import * as Types from 'types/types';

export function getDocumentTypeFromFilename(filename: string): Types.DocumentType | null {
  const extension = filename.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'pdf':
      return 'pdf';
    case 'docx':
      return 'docx';
    case 'md':
      return 'markdown';
    case 'txt':
      return 'txt';
    default:
      return null;
  }
}
